import { render } from "./edit_delivery_company.vue?vue&type=template&id=fe5dd03c&scoped=true"
import script from "./edit_delivery_company.vue?vue&type=script&lang=js"
export * from "./edit_delivery_company.vue?vue&type=script&lang=js"

import "./edit_delivery_company.vue?vue&type=style&index=0&id=fe5dd03c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5dd03c"]])

export default __exports__